export const formatCurrency = (
  amount: number,
  decimalPlaces?: number,
): string => {
  return amount.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    ...(decimalPlaces !== undefined && {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }),
  });
};

export const formatRate = (rate: number): string => {
  return (rate * 100).toFixed(1) + '%';
};
